import React from 'react';
import { render } from 'react-dom';
import PosessionModal from "./components/PosessionModal";

const posessionModalFlowNodes = document.querySelectorAll('.toggle-posession-modal');

posessionModalFlowNodes.forEach((node) => {
    const detachUrl =
        typeof node.dataset.detachUrl !== "undefined" ? node.dataset.detachUrl : "";

    node.addEventListener('click', () => {
        render(
            <PosessionModal
            detachUrl={detachUrl}
                modalOpen={true}
                setModalOpen={() => {
                    render(null, document.getElementById('posession-modal'));
                }}
            />,
            document.getElementById('posession-modal')
        );
    });
});

